export const STAKE_STATUS = Object.freeze({
  upComing: 1,
  inComing: 2,
  ended: 3,
});

export const defaultStake = {
  totalRebateCoin: '0',
  stakingName: '-------',
  returnOfRate: '0;0',
  leastHoldCoin: '0',
  lastEarningRate: '0.0',
  thirtyDaysHoldCoin: '0',
  holdCoin: 'XXX',
  rebateCoin: 'XXX',
  startTime: '1970-01-01',
  endTime: '2046-12-25',
  status: STAKE_STATUS.inComing,
  tags: null,
  list: [],
  stakingDesc: 'desc',
};
